module.exports = __webpack_public_path__ + "tip.png?bf5a282719a84bfe959a5b0c9f017beb";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tip.png
// module id = 230
// module chunks = 0